import { render } from "./Stair.vue?vue&type=template&id=7ecb1498&scoped=true"
import script from "./Stair.vue?vue&type=script&lang=js"
export * from "./Stair.vue?vue&type=script&lang=js"

import "./Stair.vue?vue&type=style&index=0&id=7ecb1498&lang=scss&scoped=true"

import exportComponent from "/opt/cah/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ecb1498"]])

export default __exports__